import React, { useState } from 'react';

function BidderTable({ bidders }) {
  const [sortKey, setSortKey] = useState('requests');
  const [sortDir, setSortDir] = useState('desc');

  if (!bidders || bidders.length === 0) {
    return <div className="empty-state"><p>No bidder data available.</p></div>;
  }

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDir('desc');
    }
  };

  const sorted = [...bidders].sort((a, b) => {
    const diff = (a[sortKey] || 0) - (b[sortKey] || 0);
    return sortDir === 'asc' ? diff : -diff;
  });

  const getSeverityClass = (row) => {
    if (row.timeoutRate > 0.3 || row.noBidRate > 0.7) return 'severity-critical';
    if (row.timeoutRate > 0.15 || row.noBidRate > 0.5) return 'severity-warning';
    return '';
  };

  const pct = (v) => ((v || 0) * 100).toFixed(1) + '%';

  return (
    <div className="data-table">
      <table>
        <thead>
          <tr>
            <th onClick={() => handleSort('bidderCode')}>Bidder</th>
            <th onClick={() => handleSort('requests')}>Requests</th>
            <th onClick={() => handleSort('responses')}>Responses</th>
            <th onClick={() => handleSort('noBids')}>No-Bids</th>
            <th onClick={() => handleSort('timeouts')}>Timeouts</th>
            <th onClick={() => handleSort('noBidRate')}>No-Bid %</th>
            <th onClick={() => handleSort('timeoutRate')}>Timeout %</th>
            <th onClick={() => handleSort('avgCpm')}>Avg CPM</th>
            <th onClick={() => handleSort('winRate')}>Win %</th>
            <th onClick={() => handleSort('avgResponseTime')}>Avg Resp (ms)</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((b) => (
            <tr key={b.bidderCode} className={getSeverityClass(b)}>
              <td><strong>{b.bidderCode}</strong></td>
              <td>{b.requests?.toLocaleString()}</td>
              <td>{b.responses?.toLocaleString()}</td>
              <td>{b.noBids?.toLocaleString()}</td>
              <td>{b.timeouts?.toLocaleString()}</td>
              <td>{pct(b.noBidRate)}</td>
              <td>{pct(b.timeoutRate)}</td>
              <td>${b.avgCpm?.toFixed(2)}</td>
              <td>{pct(b.winRate)}</td>
              <td>{b.avgResponseTime?.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default BidderTable;
